import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=d366971a"
import script from "./CustomerDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports